import { render } from "./success.vue?vue&type=template&id=6c6290b4&scoped=true"
import script from "./success.vue?vue&type=script&lang=js"
export * from "./success.vue?vue&type=script&lang=js"

import "./success.vue?vue&type=style&index=0&id=6c6290b4&lang=scss&scoped=true"
import "./success.vue?vue&type=style&index=1&id=6c6290b4&lang=scss"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c6290b4"]])

export default __exports__